import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Button, Text } from '@frontend/design-system';
import { containerStyle } from './task-popover-heading.styles';

interface TaskPopoverHeadingProps {
  label: string;
  onClear: () => void;
  disableClear?: boolean;
  trackingId?: string;
}

export const TaskPopoverHeading: FC<TaskPopoverHeadingProps> = ({ label, onClear, disableClear, trackingId }) => {
  const { t } = useTranslation('task-center');
  return (
    <span css={containerStyle}>
      <Text weight='bold'>{label}</Text>
      <Button onClick={onClear} variant='tertiary' disabled={disableClear} trackingId={trackingId}>
        {t('Clear')}
      </Button>
    </span>
  );
};
